export class UncategorizedDocumentError extends Error {
    constructor(message: string = "Não é possível submeter documentos não categorizados") {
        super(message)
        this.name = "UncategorizedDocumentError"
    }
}
